import i18nFactory from '@yandex-int/i18n';
import { isUndefined } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ResourceType } from '../common/typings';
import { Gallery } from '../Gallery/Gallery';
import { GalleryItemAudio } from '../GalleryItemAudio/GalleryItemAudio';
import {
    CommonGalleryProps,
    GalleryAudioCollectionItem,
    GalleryPaneTypes,
    PreviewAudioItemParams
} from '../GalleryPane/typings';
import { GalleryPaneOrderFilterProps } from '../GalleryPaneFilters/GalleryPaneFilters';
import { RecentOrderSelector } from '../RecentOrderSelector/RecentOrderSelector';

import './CanvasAudioGallery.css';
import * as keyset from './CanvasAudioGallery.i18n';

const i18n = i18nFactory(keyset);

interface CanvasAudioGalleryFiltersProps extends GalleryPaneOrderFilterProps {}

export interface CanvasAudioGalleryProps extends CanvasAudioGalleryFiltersProps, CommonGalleryProps {
    currentPaneCollection: GalleryAudioCollectionItem[];
    previewAudioItem: (pane: GalleryPaneTypes, params?: PreviewAudioItemParams) => void;
}

export class CanvasAudioGallery extends React.PureComponent<CanvasAudioGalleryProps> {
    render() {
        const { preview, isPopupOpened } = this.props;
        const audioSource = preview ? (preview.itemSource as string) : undefined;

        const props = {
            ...this.props,
            parentBlockName: 'canvas-audio-gallery',
            itemRenderer: this.itemRenderer,
            paneFilterRenderer: this.paneFilterRenderer,
            header: i18n('audio-title'),
            resourceType: ResourceType.audio
        };

        return (
            <>
                {isPopupOpened && audioSource && (
                    <audio
                        className={Bem.cls('canvas-audio-gallery', 'audio')}
                        src={audioSource}
                        controls={true}
                        autoPlay={true}
                    />
                )}
                <Gallery {...props} />
            </>
        );
    }

    private paneFilterRenderer = (paneType: GalleryPaneTypes): React.ReactNode => {
        const { recentOrder, changeRecentOrder } = this.props;

        if (paneType === GalleryPaneTypes.recent) {
            return <RecentOrderSelector change={changeRecentOrder} value={recentOrder} />;
        }

        return;
    };

    private previewItem = (itemIndex?: number): void => {
        const { previewAudioItem, currentPaneType, currentPaneCollection } = this.props;

        if (!isUndefined(itemIndex)) {
            const item = currentPaneCollection[itemIndex];

            previewAudioItem(currentPaneType, {
                itemIndex,
                itemSource: item.url
            });
        } else {
            previewAudioItem(currentPaneType);
        }
    };

    private itemRenderer = (index: number): React.ReactNode => {
        const { removeItem, applyItem, preview, currentPaneType } = this.props;
        const item = this.props.currentPaneCollection[index];
        const isPlaying = preview && preview.paneType === currentPaneType && preview.itemIndex === index;

        return (
            <GalleryItemAudio
                key={`gallery-item-${item.id}`}
                durationLabel={item.durationLabel}
                isPlaying={isPlaying}
                name={item.name}
                removable={item.removable}
                applyItem={applyItem}
                removeItem={removeItem}
                previewItem={this.previewItem}
                collectionIndex={index}
            />
        );
    };
}
